// extracted by mini-css-extract-plugin
module.exports = {"grid":"LensGrid_grid__tb0J2","item":"LensGrid_item__Kxttt"};